import styled from 'styled-components'

export const Container = styled.div`
    /* display: flex; */
    height: 100vh;
    background: #fff;
    overflow: auto;
    /* padding: 0 20px; */

    @media (min-width: 1000px) {
        display: flex;
        flex-direction: row;
        /* align-items: stretch; */
    }
`
export const Content = styled.div`
    flex-shrink: 0;
    flex-grow: 8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    @media (min-width: 1000px) {
        justify-content: center;
    }
`

export const RegisterContainer = styled.div`
    margin: auto;
    padding: 0 20px;
`
export const Infos = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
        width: 200px;
        height: auto;

        @media (max-width: 400px) {
            /* margin-top: 50px; */
        }
    }

    > h2 {
        font-family: 'Roboto', sans-serif;
        /* color: #03cc95; */
        color: #333;
        font-weight: 500;
        margin: 20px 0;
        font-size: 30px;
    }

    > h1 {
        font-family: 'Inter', sans-serif;
        /* color: #333; */
        /* color: #03cc95; */
        color: #333;
        font-weight: 500;
        font-size: 32px;
        /* margin: 15px 0; */
        margin-bottom: 10px;
    }

    > p {
        margin-bottom: 30px;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        color: #333;
        text-align: center;
    }

    > span {
        font-size: 12px;
        color: #333;
        margin-bottom: 30px;
    }
    /* @media (min-width: 1200px) {
    min-width: 650px;
  } */
    /* @media (min-width: 1440px) {
    min-width: 800px;
  }  */
`
export const Form = styled.form`
    width: 100%;
    padding-top: 10px;
    overflow-y: scroll;
    overflow-x: hidden;

    ::-webkit-scrollbar {
        width: 4px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: #333;
        border-radius: 10px;
    }
    ::-webkit-scrollbar-track {
        background-color: #d3d3d3;
    }
    > div {
        padding-right: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin-bottom: 30px;

        > input {
            width: 100%;
            border-radius: 5px;
            border: 1px solid #d3d3d3;
            height: 40px;
            padding: 0px 16px;

            font-size: 18px;
            font-family: 'Roboto', sans-serif;
            font-weight: 300;
        }

        > label {
            color: #333;
            font-size: 20px;
        }
    }

    @media (min-width: 980px) {
        width: 420px;
    }
`
